import React from "react";

import Drag from "../FormComponent/Drag";
import Bin from "../FormComponent/Bin";
import Copy from "../FormComponent/Copy";
import FieldLabel from "./InputTypes/FieldLabel";
import FieldPlaceHolder from "./InputTypes/FieldPlaceHolder";
import FieldRequired from "./InputTypes/FieldRequired";
import FieldType from "./InputTypes/FieldType";

const updateField = ["Label", "Required", "PlaceHolder"];

const TextArea = (props) => {
  
  const isTemplateMode = props.mode === "Template";

  return (
    <div className={`${isTemplateMode ? `p-9` : ``} form-group field-wraper`}>
      <div className={`field-content ${isTemplateMode ? `row` : ``}`}>
        
        {isTemplateMode ? <div className="col-md-1 pl-0"><Drag /></div> : null}
        
        <div className={isTemplateMode ? `col-md-4` : `col-md-12`}>
          <FieldLabel
            idValue={props.fieldItem.fieldId}
            errors={props.errors}
            value={props.fieldItem.fieldLabel}
            changeHandler={(event) =>
              props.updatedField(event, props.fieldItem.fieldId, updateField[0])
            }
          />
          
        </div>
        <div className={isTemplateMode ? `col-md-4` : `col-md-12 mt-5`}>
          <FieldType
            changeFieldHandler={(event) =>
              props.changeFieldHandler(
                event,
                props.fieldItem.fieldId,
                props.fieldItem.inputType,
                props.sectionId
              )
            }
            inputType={props.fieldItem.inputType}
          />
        </div>
        <div className={isTemplateMode ? `col-md-2 pl-0` : `col-md-12`} >
          <FieldRequired
            fieldId={props.fieldItem.fieldId}
            isChecked={props.fieldItem.fieldRequired}
            changeHandler={(event) =>
              props.updatedField(event, props.fieldItem.fieldId, updateField[1])
            }
          />
        </div>
        {isTemplateMode ? (
        <div className="col-md-1 d-flex" >
          <Copy
            copyFieldHandler={() =>
              props.copyFieldHandler(
                props.fieldItem.fieldId,
                props.fieldItem.inputType,
                props.sectionId
              )
            }
          />
          {props.index > 0 && (
            <Bin
              deleteHandler={() =>
                props.deleteFieldHandler(props.fieldItem.fieldId)
              }
            />
          )}
        </div>) : null }
        <div className={isTemplateMode ? `col-md-4 offset-md-1` : `col-md-12`} >
          <FieldPlaceHolder
            value={props.fieldItem.fieldPlaceHolder}
            changeHandler={(event) =>
              props.updatedField(event, props.fieldItem.fieldId, updateField[2])
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TextArea;
